export default {
      id: "create_program-usage",
      viewBox: "0 0 17.64 17.5",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#create_program",
      toString: function () {
        return this.url;
      }
    }